<template>
  <div :class="{ 'h5-nav-icon': isH5, 'pc-nav-icon': !isH5 }" class="nav-icon">
    <!-- <p class="content-title">{{ moduleInfo.module_title }}</p> -->
    <ul class="list-wrap">
      <li v-for="item in moduleInfo.content_list" :key="item.id">
        <img
          :src="item.cover_url + '?imageView2/0/w/100'"
          alt=""
          @click="jumpUrl(item.jump_url)"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { isH5 } from "@saas/components/src";
export default {
  props: {
    moduleInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: function () {
    return {
      isH5: isH5(),
    };
  },
  methods: {
    jumpUrl(url) {
      if (window.isElectron) {
        window.openUrlByExternal(url);
      } else {
        window.open(url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-nav-icon {
  // .content-title {
  //   padding-bottom: 24px;
  // }
  .list-wrap {
    display: flex;
    justify-content: space-between;
    img {
      width: 80px;
      height: 80px;
      cursor: pointer;
      object-fit: cover;
    }
  }
}
@media (max-width: 767px) {
  .h5-nav-icon {
    // .content-title {
    //   padding-bottom: 0.43rem;
    // }
    .list-wrap {
      display: flex;
      justify-content: space-between;
      img {
        width: 1.07rem;
        height: 1.07rem;
        object-fit: cover;
      }
    }
  }
}
</style>
